var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path 2")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Typography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Building-blocks",
    transform: "translate(-91.000000, -1143.000000)",
    stroke: "#F2F2F7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Options",
    transform: "translate(88.000000, 1127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input/Checkbox/Unchecked",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Check",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "0.494285583 2.83210458 2.62423982 5.00569419 7.13266754 0.658514977"
  }))))))));
};
export { SvgIconCheck as ReactComponent };
export default __webpack_public_path__ + "icon-check.svg";